import React from "react";
import { Typography } from "@mui/material";

const ShimmeringText = ({ text }) => (
  <Typography
    component="span"
    sx={{
      background: "linear-gradient(90deg, #999, #bbb, #999)",
      backgroundSize: "200% auto",
      color: "transparent",
      backgroundClip: "text",
      WebkitBackgroundClip: "text",
      animation: "shimmerText 1.5s ease-in-out infinite",
      fontSize: 14,
      fontStyle: "italic",
      fontWeight: 500,
      lineHeight: 1.5,
      textShadow: "0 0 0.3px rgba(0,0,0,0.2)", // slight fallback glow
    }}
  >
    {text}
    <style>
      {`
        @keyframes shimmerText {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
      `}
    </style>
  </Typography>
);

export default ShimmeringText;
